module.exports = __webpack_public_path__ + "public/images/stand-bg.1358bf2e44c52928e1b2bf41fa92be0d.jpg";